require("front/ipad/main")